import { AppDialog } from "../../../common/components/AppDialog/AppDialog";
import { aiAssistantTexts } from "../models/aiAssistantModels";
import styles from "./AiMessages.module.scss";

interface IAiImagePreviewDialogProps {
  url: string | null;
  onHide: () => void;
}

/** An attached image at full size; opens from a thumbnail in the chat. */
export const AiImagePreviewDialog = ({ url, onHide }: IAiImagePreviewDialogProps) => {
  return (
    <AppDialog
      header={aiAssistantTexts.imagePreview}
      visible={!!url}
      onHide={onHide}
      className={styles.preview_dialog}
      contentClassName={styles.preview_content}
      dismissableMask
    >
      {url && <img className={styles.preview_image} src={url} alt={aiAssistantTexts.imagePreview} />}
    </AppDialog>
  );
};
